export function setupPurechat() { 
    window.purechatApi = { l: [], t: [], on: function () { this.l.push(arguments); } };
    var done = false; 
    var script = document.createElement('script'); 
    script.async = true; 
    script.type = 'text/javascript'; 
    script.src = 'https://app.purechat.com/VisitorWidget/WidgetScript'; 
    document.getElementsByTagName('HEAD').item(0).appendChild(script); 
    script.onreadystatechange = script.onload = function (e) { 
        if (!done && (!this.readyState || this.readyState == 'loaded' || this.readyState == 'complete')) { 
            var w = new PCWidget({c: '3cac0077-eb22-44e9-9820-cd969613e737', f: true }); 
            done = true; 
        } 
    }; 
}